export const useBikefinder = () => {
    const app = useNuxtApp();
    const bikefinderStore = useBikefinderStore();
    const route = useRoute();
    const localePath = useLocalePathWoom();
    const { iso2Country } = useLocales();

    // In case we want to exclude the bikefinder in other stores too
    const excludedShops = ['uk'];

    const { bikefinderLink } = storeToRefs(bikefinderStore);

    const bikefinderLocaleUrl = computed(() => {
        if (!bikefinderLink.value) return;
        return localePath(bikefinderLink.value);
    });

    const isBikefinder = computed(() => {
        return route.path === bikefinderLocaleUrl.value;
    });

    const showBikefinderButton = computed(() => {
        return bikefinderLink.value && !excludedShops.includes(iso2Country.value.toLowerCase());
    });

    const handleBikefinder = () => {
        app.$gtm?.pushEvent({
            event: 'bike_finder',
        });
    };

    return {
        isBikefinder,
        showBikefinderButton,
        bikefinderLocaleUrl,
        handleBikefinder,
    };
};
